import React from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { theme, useResponsive } from '@sweetgreen/garnish';

export const CheckoutLayout = (props: ViewProps) => {
  const { children } = props;

  const { match } = useResponsive();
  const style = match([styles.layoutXS, styles.layoutSM, styles.layoutMD]);

  return <View style={style}>{children}</View>;
};

//
// ─── SUBCOMPONENTS ──────────────────────────────────────────────────────────────
//

export const CheckoutLayoutColumn = (props: CheckoutLayoutColumnProps) => {
  const { children, shouldFitToFill = false } = props;

  const { match } = useResponsive();
  const style = match([styles.columnXS, styles.columnSM, styles.columnMD]);

  return (
    <View style={[shouldFitToFill && styles.fitToFill, style]}>{children}</View>
  );
};

export const CheckoutLayoutBlock = ({ testID, children }: ViewProps) => {
  const { match } = useResponsive();
  const layoutBlockResponsiveStyle = match([
    styles.layoutBlockXS,
    styles.layoutBlockSM,
  ]);
  const layoutBlockInnerResponsiveStyle = match([
    styles.layoutBlockInnerResponsiveXS,
    styles.layoutBlockInnerResponsiveSM,
    styles.layoutBlockInnerResponsiveMD,
  ]);
  const layoutBlockInnerStyle = [
    styles.layoutBlockInner,
    layoutBlockInnerResponsiveStyle,
  ];

  return (
    <View testID={testID} style={layoutBlockResponsiveStyle}>
      <View style={layoutBlockInnerStyle}>{children}</View>
    </View>
  );
};

//
// ─── TYPES ──────────────────────────────────────────────────────────────────────
//

type CheckoutLayoutColumnProps = ViewProps & {
  shouldFitToFill?: boolean;
};

//
// ─── STYLES ─────────────────────────────────────────────────────────────────────
//

const GUTTER_SIZE = theme.spacing['3'];

const styles = StyleSheet.create({
  layoutXS: {
    flexGrow: 1,
    rowGap: theme.spacing['10'],
  },
  layoutSM: {},
  layoutMD: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginRight: -GUTTER_SIZE,
    marginLeft: -GUTTER_SIZE,
  },

  fitToFill: {
    flexGrow: 1,
  },
  columnXS: {
    rowGap: theme.spacing['10'],
  },
  columnSM: {},
  columnMD: {
    flexBasis: '50%',
    paddingHorizontal: GUTTER_SIZE,
  },

  layoutBlockXS: {
    flexGrow: 1,
  },
  layoutBlockSM: {
    paddingBottom: theme.spacing['6'],
  },
  layoutBlockInnerResponsiveXS: {
    flexGrow: 1,
  },
  layoutBlockInner: {
    backgroundColor: theme.colors.OATMEAL,
  },
  layoutBlockInnerResponsiveSM: {
    padding: theme.spacing['10'],
    borderRadius: theme.radius.large,
  },
  layoutBlockInnerResponsiveMD: {
    padding: theme.spacing['10'],
    borderRadius: theme.radius.medium,
  },
});
